// A year page with a sidebar, one column on a narrow screen (Year/About.vue; Seán, 2026-10-22):
// the top stays put as the content scrolls under it: the banner (fixed already), the header, the
// year's menu and the sidebar's control (global.css body.isPinnedTop). Each is pinned below the
// ones above it (and Highlights' dots below the control), by their heights (measured: they change with the width and the font); the
// header takes a solid background once the page has scrolled (body.isScrolled), so the content
// doesn't show through it.
import {useEventListener, useResizeObserver} from "@vueuse/core";

const getHeader = () => document.querySelector("#app header");
const getYearMenu = () => document.querySelector("#NavBar");

function setHeights() {
  const style = document.body.style;
  style.setProperty("--pinned-header-h", `${getHeader()?.offsetHeight || 0}px`);
  style.setProperty("--pinned-menu-h", `${getYearMenu()?.offsetHeight || 0}px`);
  const control = document.querySelector(".yearSidebar .segmented");
  style.setProperty("--pinned-control-h", `${control?.offsetHeight || 0}px`);
}
const setScrolled = () => document.body.classList.toggle("isScrolled", window.scrollY > 0);

export function setPinnedTop(isOn) {
  document.body.classList.toggle("isPinnedTop", isOn);
  if (!isOn) return document.body.classList.remove("isScrolled");
  setHeights();
  setScrolled();
}

// once, for the page: heights and scroll kept current while pinned
export function usePinnedTop() {
  const isPinned = () => document.body.classList.contains("isPinnedTop");
  useResizeObserver(document.body, () => isPinned() && setHeights());
  useEventListener(window, "scroll", () => isPinned() && setScrolled(), {passive: true});
}
